import { Metadata } from '../../../../utils/spds/metadata';
import Super from './base.gjs';

const METADATA = Metadata.define({
  description: `
Flex column layout component

A convenience wrapper around \`Spds::Core::Container\` that renders a flexbox column. It sets \`@column={{true}}\` on the
underlying container, so there is no need to repeat that argument in templates.
  `,
  name: 'Flex Column',
});

export default class SpdsLayoutFlexColumn extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  column = true;
  variantClass = 'spds-layout-flex-column';
}

export const LAYOUT_FLEX_COLUMN_METADATA = SpdsLayoutFlexColumn.metadata;
